import React from "react";

const ChecklistCheckbox = ({ name, label, onChange, checked }) => (
  <div className="checklist-checkbox">
    <input type="checkbox" name={name} onChange={onChange} checked={checked} id={name} />
    <label htmlFor={name}>{label}</label>
  </div>
);

export default ChecklistCheckbox;
